import React, { useState, useEffect } from "react";
import NavbarLeft from "./../Components/NavbarLeft";
import { ReactComponent as BackArrow } from "../../assets/navbar/BackArrow.svg";
import { Link } from "react-router-dom";
import ReductionOption from "../Components/ReductionOption";
import EcoA from "../../assets/ecoscore/eco_A.png";
import EcoB from "../../assets/ecoscore/eco_B.png";
import EcoC from "../../assets/ecoscore/eco_C.png";
import EcoD from "../../assets/ecoscore/eco_D.png";
import EcoE from "../../assets/ecoscore/eco_E.png";
import Slider from "@mui/material/Slider";
import { ReactComponent as Cross } from "../../assets/analyse/Cross.svg";
import { styled } from "@mui/material/styles";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { fetchImpactIndicators } from "../../redux/actions/analysisActions";
import { resetOptimisationStatus } from "../../redux/actions/optimizationActions";
import { setUserOnboardingStep, setUserOnboardingStepLocal } from "../../redux/actions/userActions";
import { useNavigate } from "react-router-dom";
import { ToastWarn } from "../../commonComponents/ToastHelper";
import { convert_eco_value_to_letter } from "../../utils/utils.js";

const ReduceParametersChoice = () => {
  const navigate = useNavigate();
  const analysis_data = useSelector((state) => state.analysis.analysis_data, shallowEqual); //? state.analysis.analysis_data : null)
  const impact_indicators = useSelector((state) => (state.analysis.impact_indicators ? state.analysis.impact_indicators : null));

  const dispatch = useDispatch();
  const fetchImpactIndicators_rd = () => dispatch(fetchImpactIndicators());
  const resetOptimisationStatus_rd = () => dispatch(resetOptimisationStatus());

  const user_info = useSelector((state) => (state.user.user_info ? state.user.user_info : null));
  const setUserOnboardingStep_rd = (item) => dispatch(setUserOnboardingStep(item));
  const setUserOnboardingStepLocal_rd = (item) => dispatch(setUserOnboardingStepLocal(item));

  const handleChangeOnboardingStep = (item) => {
    setUserOnboardingStep_rd(item);
    setUserOnboardingStepLocal_rd(item);
  };

  useEffect(() => {
    const fetchImpactIndicators_fn = async () => {
      await fetchImpactIndicators_rd();
    };
    if (!impact_indicators) {
      fetchImpactIndicators_fn();
    }
  }, []);

  const [cibles, setCibles] = useState({
    Recette: { transport: false, energy: false, packaging: false },
    Packaging: { transport: false, energy: false, packaging: false },
    Distribution: { transport: false, energy: false, packaging: false },
    VenteAuDetail: { transport: false, energy: false, packaging: false },
    Consommation: { transport: false, energy: false, packaging: false },
  });
  const [target, setTarget] = useState(0);
  const [sliderScore, setSliderScore] = useState(analysis_data && parseFloat(analysis_data.eco_score));
  const [selectedEcoscore, setSeclectedEcoscore] = useState({ type: "eco_score", value: analysis_data && convert_eco_value_to_letter(parseFloat(analysis_data.eco_score)) });
  const [procedeMenu, SetProcedeMenu] = useState(0);
  const [procedeFilter, setProcedeFilter] = useState("");

  const [chosenProcede, setChosenProcede] = useState(
    impact_indicators
      ? impact_indicators[1]
      : {
          id: "da32f256-618d-4bec-a8d9-205817788b26",
          name: {"en":"Unique score", "fr":"Score unique"},
          ref_unit: "mPt",
          norm_factor: 1,
          pond_factor: 1,
          description: "no data yet...",
          width: 200,
        }
  );

  const handleChangeSelectedEcoScore = (item) => {
    setSeclectedEcoscore(item);
    // update onboarding step
    if (user_info.usage_info && user_info.usage_info.onboarding_step < 5) {
      handleChangeOnboardingStep(5);
    }
  };

  const handleChangeSliderScore = (item) => {
    setSliderScore(item);
    // update onboarding step
    if (user_info.usage_info && user_info.usage_info.onboarding_step < 5) {
      handleChangeOnboardingStep(5);
    }
  };

  return (
    <>
      <NavbarLeft currentPage={3} />
      <div className="w-full h-[70px] bg-white border-r-[1px] border-[#BEC4C] fixed z-10 flex items-center justify-start ml-[25px]">
        <div className="w-full relative left-[70px] flex justify-start items-center">
          <Link to="/ReduceScenarioChoice">
            <BackArrow />
          </Link>
          <p className="font-Poppins-SemiBold text-lg relative p-10">{"Réduire - Scénario analysé - " + analysis_data.lca.lca_steps[0].ciqual_name.fr}</p>
        </div>
      </div>
      <div>
        <div className="mt-[80px] ml-[150px] w-[1200px] h-[280px]">
          <p className="text-2xl font-Poppins-SemiBold">Définir l'objectif</p>
          <div className="w-full h-[250px] flex justify-between items-center mt-[-10px]">
            {target === 0 ? (
              <>
                <div className="rounded-xl w-[500px] h-[190px] bg-white border-[2px] border-mainGreen shadow-lg">
                  <div className="h-[70px] flex justify-center items-center">
                    <p className="font-Poppins-SemiBold text-2xl">Eco-score</p>
                  </div>
                  <div className="w-full h-[90px] flex justify-center items-center">
                    <div className="w-[380px] h-full flex justify-between items-center">
                      <button
                        onClick={() => {
                          handleChangeSelectedEcoScore({ ...selectedEcoscore, value: "A" });
                        }}
                        className={`${selectedEcoscore.value === "A" ? "border-[#1E8F4E] border-[5px] rounded-xl" : " border-[5px] border-white"}`}
                      >
                        <img src={EcoA} className="h-[80px]" />
                      </button>
                      <button
                        onClick={() => {
                          handleChangeSelectedEcoScore({ ...selectedEcoscore, value: "B" });
                        }}
                        className={`${selectedEcoscore.value === "B" ? "border-[#2ECC71] border-[5px] rounded-xl" : " border-[5px] border-white"}`}
                      >
                        <img src={EcoB} className="h-[80px]" />
                      </button>
                      <button
                        onClick={() => {
                          handleChangeSelectedEcoScore({ ...selectedEcoscore, value: "C" });
                        }}
                        className={`${selectedEcoscore.value === "C" ? "border-[#F5C100] border-[5px] rounded-xl" : " border-[5px] border-white"}`}
                      >
                        <img src={EcoC} className="h-[80px]" />
                      </button>
                      <button
                        onClick={() => {
                          handleChangeSelectedEcoScore({ ...selectedEcoscore, value: "D" });
                        }}
                        className={`${selectedEcoscore.value === "D" ? "border-[#EF7E1A] border-[5px] rounded-xl" : " border-[5px] border-white"}`}
                      >
                        <img src={EcoD} className="h-[80px]" />
                      </button>
                      <button
                        onClick={() => {
                          handleChangeSelectedEcoScore({ ...selectedEcoscore, value: "E" });
                        }}
                        className={`${selectedEcoscore.value === "E" ? "border-[#D93726] border-[5px] rounded-xl" : " border-[5px] border-white"}`}
                      >
                        <img src={EcoE} className="h-[80px]" />
                      </button>
                    </div>
                  </div>
                  <div className="w-full h-[30px] flex items-center justify-center text-xs font-Poppins-Light">{selectedEcoscore === 0 ? <p>Actuel</p> : <p>Objectif</p>}</div>
                </div>
                <button onClick={() => setTarget(1)} className="rounded-xl w-[500px] h-[190px] bg-white opacity-50">
                  <div className="h-[70px] flex justify-left items-center">
                    <div className="mt-[5px] ml-[10px]">
                      {sliderScore <= 20 ? <img src={EcoE} className="h-[40px]" /> : null}
                      {sliderScore > 20 && sliderScore <= 40 ? <img src={EcoD} className="h-[40px]" /> : null}
                      {sliderScore > 40 && sliderScore <= 60 ? <img src={EcoC} className="h-[40px]" /> : null}
                      {sliderScore > 60 && sliderScore <= 80 ? <img src={EcoB} className="h-[40px]" /> : null}
                      {sliderScore > 80 && sliderScore <= 100 ? <img src={EcoA} className="h-[40px]" /> : null}
                    </div>
                    <p className="font-Poppins-SemiBold text-2xl ml-[150px]">Score EF</p>
                  </div>
                  <div className="w-full flex justify-center items-center">
                    <p className="p-[20px] text-xs font-Poppins-Light">0</p>
                    <div className="h-[120px] w-[400px] flex justify-center items-center">
                      <Slider
                        disabled
                        valueLabelDisplay="on"
                        defaultValue={sliderScore}
                        sx={{
                          color:
                            sliderScore > 80
                              ? "#1E8F4E"
                              : sliderScore > 60 && sliderScore <= 80
                              ? "#2ECC71"
                              : sliderScore > 40 && sliderScore <= 60
                              ? "#F5C100"
                              : sliderScore > 20 && sliderScore <= 40
                              ? "#EF7E1A"
                              : sliderScore <= 20
                              ? "#D93726"
                              : null,
                        }}
                        onChange={(event, newValue) => {
                          handleChangeSliderScore(newValue);
                        }}
                      />
                    </div>
                    <p className="p-[20px] text-xs font-Poppins-Light">100</p>
                  </div>
                </button>
              </>
            ) : (
              <>
                <button
                  onClick={() => {
                    setTarget(0);
                  }}
                  className="rounded-xl w-[500px] h-[190px] bg-white opacity-50"
                >
                  <div className="h-[70px] flex justify-center items-center">
                    <p className="font-Poppins-SemiBold text-2xl">Eco-score</p>
                  </div>
                  <div className="w-full h-[90px] flex justify-center items-center">
                    <div className="w-[380px] h-full flex justify-between items-center">
                      <div className={`${selectedEcoscore === 0 ? "border-mainGreen border-[5px] rounded-xl" : " border-[5px] border-white"}`}>
                        <img src={EcoA} className="h-[80px]" />
                      </div>
                      <div className={`${selectedEcoscore === 1 ? "border-mainGreen border-[5px] rounded-xl" : " border-[5px] border-white"}`}>
                        <img src={EcoB} className="h-[80px]" />
                      </div>
                      <div className={`${selectedEcoscore === 2 ? "border-mainGreen border-[5px] rounded-xl" : " border-[5px] border-white"}`}>
                        <img src={EcoC} className="h-[80px]" />
                      </div>
                      <div className={`${selectedEcoscore === 3 ? "border-mainGreen border-[5px] rounded-xl" : " border-[5px] border-white"}`}>
                        <img src={EcoD} className="h-[80px]" />
                      </div>
                      <div className={`${selectedEcoscore === 4 ? "border-mainGreen border-[5px] rounded-xl" : " border-[5px] border-white"}`}>
                        <img src={EcoE} className="h-[80px]" />
                      </div>
                    </div>
                  </div>
                  <div className="w-full h-[30px] flex items-center justify-center text-xs font-Poppins-Light">{selectedEcoscore === 0 ? <p>Actuel</p> : <p>Objéctif</p>}</div>
                </button>
                <div className="rounded-xl w-[500px] h-[190px] bg-white border-[2px] border-mainGreen shadow-lg">
                  <div className="h-[70px] flex justify-left items-center">
                    <div className="mt-[5px] ml-[10px]">
                      {sliderScore <= 20 ? <img src={EcoE} className="h-[40px]" /> : null}
                      {sliderScore > 20 && sliderScore <= 40 ? <img src={EcoD} className="h-[40px]" /> : null}
                      {sliderScore > 40 && sliderScore <= 60 ? <img src={EcoC} className="h-[40px]" /> : null}
                      {sliderScore > 60 && sliderScore <= 80 ? <img src={EcoB} className="h-[40px]" /> : null}
                      {sliderScore > 80 && sliderScore <= 100 ? <img src={EcoA} className="h-[40px]" /> : null}
                    </div>
                    <p className="font-Poppins-SemiBold text-2xl ml-[150px]">Score EF</p>
                  </div>
                  <div className="w-full flex justify-center items-center">
                    <p className="p-[20px] text-xs font-Poppins-Light">0</p>
                    <div className="h-[120px] w-[400px] flex justify-center items-center">
                      <Slider
                        valueLabelDisplay="on"
                        defaultValue={sliderScore}
                        sx={{
                          color:
                            sliderScore > 80
                              ? "#1E8F4E"
                              : sliderScore > 60 && sliderScore <= 80
                              ? "#2ECC71"
                              : sliderScore > 40 && sliderScore <= 60
                              ? "#F5C100"
                              : sliderScore > 20 && sliderScore <= 40
                              ? "#EF7E1A"
                              : sliderScore <= 20
                              ? "#D93726"
                              : null,
                        }}
                        onChange={(event, newValue) => {
                          handleChangeSliderScore(newValue);
                        }}
                      />
                    </div>
                    <p className="p-[20px] text-xs font-Poppins-Light">100</p>
                  </div>
                </div>
              </>
            )}
          </div>

          <div className="w-full h-[450px]">
            <div className="flex justify-between items-center">
              <p className=" text-2xl font-Poppins-SemiBold">Paramètres à optimiser</p>
              <div className="flex justify-between items-center h-[40px]">
                <p>Indicateur à afficher pour la séléction des paramètres:</p>
                <div className="w-[300px]">
                  {procedeMenu === 1 ? (
                    <>
                      <div className="absolute bg-white w-[300px] h-[400px] rounded-lg z-50">
                        <div className="h-[80px] w-full flex items-center justify-evenly">
                          <input
                            placeholder="Rechercher un indicateur d'impact"
                            className="p-[20px] w-[300px] h-[30px] rounded-xl text-gray-500 bg-[#BEC4CA]/20 text-xs"
                            onChange={(event) => {
                              let result = event.target.value;
                              result = result.toLocaleLowerCase();
                              setProcedeFilter(result);
                            }}
                          />
                          <button
                            onClick={() => {
                              SetProcedeMenu(0);
                            }}
                          >
                            <Cross height={20} />
                          </button>
                        </div>
                        <div className="font-Poppins-Regular text-xs overflow-y-auto overflow-hidden h-[315px]">
                          {impact_indicators.map((current, i) => {
                            if (current.name.fr.toLocaleLowerCase().includes(procedeFilter)) {
                              return (
                                <div key={`${current}${i}`}>
                                  <button
                                    onClick={() => {
                                      setChosenProcede(current);
                                      SetProcedeMenu(0);
                                    }}
                                    className="h-[30px] w-full text-left ml-[10px] hover:bg-[#BEC4CA]/20"
                                  >
                                    {current.name.fr}
                                  </button>
                                </div>
                              );
                            }
                          })}
                        </div>
                      </div>
                    </>
                  ) : null}
                  <button className="bg-white/50 rounded-lg w-[300px] h-[30px] ml-[10px]">
                    <div
                      className="bg-[#F8FAFB] w-full h-[35px] rounded-lg flex justify-between items-center cursor-pointer"
                      onClick={() => {
                        SetProcedeMenu(1);
                      }}
                    >
                      <p className="text-xs font-Poppins-Regular ml-[10px]">{chosenProcede && chosenProcede.name.fr}</p>
                      <div className="border-l-[1px] border-[#A2A3AF] w-[50px] flex items-center justify-center">
                        <BackArrow transform="rotate(270)" />
                      </div>
                    </div>
                  </button>
                </div>
              </div>
            </div>
            <div className="h-[400px] w-[1200px]">
              <div className="flex justify-between items-center h-[200px] w-[1200px]">
                <div
                  onClick={() => {
                    {
                    }
                  }}
                >
                  <ReductionOption text={"Recette"} state={cibles} update={setCibles} indicator={chosenProcede} />
                </div>
                <div>
                  <ReductionOption text={"Packaging"} state={cibles} update={setCibles} indicator={chosenProcede} />
                </div>
                <div>
                  <ReductionOption text={"Distribution"} state={cibles} update={setCibles} indicator={chosenProcede} />
                </div>
              </div>
              <div className="flex justify-between items-center h-[200px] w-[1200px]">
                <div>
                  <ReductionOption text={"Vente au détail"} state={cibles} update={setCibles} indicator={chosenProcede} />
                </div>
                <div>
                  <ReductionOption text={"Consommation"} state={cibles} update={setCibles} indicator={chosenProcede} />
                </div>
                <div className="w-[350px] h-[180px] flex items-center justify-center">
                  <button
                    onClick={() => {
                      // any defined params
                      const cibles_cond = Object.values(cibles).some((x) => x.transport || x.energy || x.packaging);
                      if (cibles_cond) {
                        resetOptimisationStatus_rd();
                        navigate("/ReduceLoadingScreen", {
                          state: {
                            cibles: cibles,
                          },
                        });
                        if (user_info.usage_info && user_info.usage_info.onboarding_step < 6) {
                          console.log("+++changeonboarding");
                          handleChangeOnboardingStep(6);
                        }
                      } else {
                        ToastWarn("Aucun(s) paramètre(s) d'optimisatio, choisi(s).");
                      }
                    }}
                    className="bg-mainGreen text-white font-Poppins-SemiBold h-[60px] w-[250px] rounded-lg"
                  >
                    Lancer l'optimisation
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReduceParametersChoice;
